import { render, staticRenderFns } from "./AppointmentTypes.vue?vue&type=template&id=34527afb&scoped=true&"
import script from "./AppointmentTypes.vue?vue&type=script&lang=js&"
export * from "./AppointmentTypes.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTypes.vue?vue&type=style&index=0&id=34527afb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34527afb",
  null
  
)

component.options.__file = "AppointmentTypes.vue"
export default component.exports